import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // 👈 ADICIONE

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

console.log("🔥 ENV:", process.env.REACT_APP_ENV);
console.log("🔥 Firebase Project:", firebaseConfig.projectId);

const app = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApp();

/* =======================
   SERVICES
======================= */

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

/* 🔥 ESSA LINHA RESOLVE O CORS */
export const functions = getFunctions(app);

setPersistence(auth, browserLocalPersistence);

export default app;
